if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        const initialActiveMedia = this.elements.viewer?.querySelector('.is-active[data-variant-id]');
        this.currentVariantId = initialActiveMedia?.dataset?.variantId || null;

        if (!this.elements.thumbnails) return;

        if (!this.mql.matches && this.currentVariantId) {
          this.filterThumbnailsByVariant(this.currentVariantId);
        }

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      }

      filterThumbnailsByVariant(variantId) {
        if (!this.elements.thumbnails || !variantId) return;
        
        this.elements.thumbnails.querySelectorAll('.thumbnail-list__item').forEach((thumbItem) => {
          const thumbVariantId = thumbItem.dataset.variantId;
          const isThumbGeneral = thumbItem.hasAttribute('data-general-media');
          
          if (isThumbGeneral || thumbVariantId === variantId) {
            thumbItem.classList.remove('thumbnail--hidden');
          } else if (thumbVariantId) {
            thumbItem.classList.add('thumbnail--hidden');
          }
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, skipScroll = false) {
        if (document.querySelector(`[data-media-id="${mediaId}"]`)) {
          const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });

          const activeVariantId = activeMedia.getAttribute('data-variant-id');
          if (activeVariantId) {
            this.currentVariantId = activeVariantId;
          }

          if (this.currentVariantId) {
            this.elements.viewer.sliderItems.forEach((element) => {
              if (element.dataset.variantId === undefined) {
                return;
              }

              if (element.dataset.variantId !== this.currentVariantId) {
                element.classList.add('gallery__hidden');
              } else {
                element.classList.remove('gallery__hidden');
              }
            });
          }

          activeMedia.classList.add('is-active');

          if (prepend) {
            activeMedia.parentElement.prepend(activeMedia);
            if (this.elements.thumbnails) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }

          this.preventStickyHeader();
          window.setTimeout(() => {
            if (this.elements.thumbnails && !skipScroll) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
            if (!skipScroll && (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked')) {
              activeMedia.scrollIntoView({ behavior: 'smooth' });
            }
          });
          this.playActiveMedia(activeMedia);

          if (!this.elements.thumbnails) return;
          
          if (!this.mql.matches) {
            this.filterThumbnailsByVariant(this.currentVariantId);
          }

          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

          this.setActiveThumbnail(activeThumbnail);
          //       this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}

document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.querySelector('.gallery-load-more-btn');
  const hideBtn = document.querySelector('.gallery-hide-btn');
  const gallery = document.getElementById('my-gallery');
  if (loadMoreBtn && hideBtn && gallery) {
    const galleryLimit = parseInt(loadMoreBtn.getAttribute('data-gallery-limit'));
    loadMoreBtn.addEventListener('click', () => {
      gallery.querySelectorAll('.product__media-item.gallery__hidden').forEach((item) => {
        item.classList.remove('gallery__hidden');
      });
      loadMoreBtn.style.display = 'none';
      hideBtn.style.display = 'block';
    });
    hideBtn.addEventListener('click', () => {
      const items = gallery.querySelectorAll('.product__media-item');
      items.forEach((item, idx) => {
        if (idx >= galleryLimit && !item.querySelector('.gallery-load-more-btn')) {
          item.classList.add('gallery__hidden');
        }
      });
      loadMoreBtn.style.display = 'block';
      hideBtn.style.display = 'none';
      if (items.length > 0) {
        items[0].scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});
